export default "__VITE_ASSET__DXC$b9Sx__"